import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Axios from "axios";
import jwtDecode from "jwt-decode";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";

import PaypalLogo from "../../../Assets/Images//paypal.png";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { url } from "../../../config/config";
import RentDialogBox from "./RentDialogBox.js/RentDialogBox";
import CustomerKhaltiPay from "../../../Component/KhaltiPay/CustomerKhaltiPay";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import { useStyles } from "./RentBook.css";

class RentBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      days: 0,
      dialogOpen: false,
      payType: "",
      emailVerified: false,
      book: [],
      totalPrice: 0,
      changedCurrency: "",
      orderId: sessionStorage.getItem("orderId"),
      validate: "",
      isEmpty: false,
      daysRef: createRef(),
    };
  }

  componentDidMount() {
    this.getBook(this.props.match.params.bookId);
    this.decodeToken(this.props.userToken);
  }

  decodeToken = async (userToken) => {
    try {
      const data = await jwtDecode(userToken);
      this.setState({
        emailVerified: data.isVerified,
      });
    } catch (error) {}
  };

  getCurrency = async () => {
    const response = await Axios.get(
      "https://api.exchangerate.host/convert?from=NPR&to=USD"
    );
    this.setState({
      changedCurrency:
        Math.round(this.state.totalPrice * response.data.result * 100) / 100,
    });
  };

  getBook = async (bookId) => {
    const response = await Axios.get(`${url}/api/books/${bookId}`);
    if (response.data.length !== 0) {
      this.setState({
        book: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        book: [],
        isEmpty: true,
      });
    }
  };

  handleChange = (e) => {
    this.checkDays(e.target.value);
    this.setState({
      days: e.target.value,
      totalPrice: e.target.value * 8,
    });
  };

  checkDays = (days) => {
    if (parseInt(days) > 0) {
      this.setState({
        validate: true,
      });
    } else {
      this.setState({
        validate: false,
      });
    }
  };

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  handleDialogOpen = (type) => {
    if (type === "paypal") {
      this.getCurrency();
    }
    this.setState({
      dialogOpen: true,
      payType: type,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  decreaseDays = () => {
    let tempDays = parseInt(this.state.days) - 1;
    this.checkDays(tempDays);
    if (tempDays < 0) {
      tempDays = 0;
    }
    this.setState({
      days: tempDays,
      totalPrice: tempDays * 8,
    });
  };

  increaseDays = () => {
    let tempDays = parseInt(this.state.days) + 1;
    this.checkDays(tempDays);
    this.setState({
      days: tempDays,
      totalPrice: tempDays * 8,
    });
  };

  render() {
    const { classes } = this.props;
    const { book, orderId } = this.state;
    return (
      <div>
        <Header />
        {book.length !== 0 ? (
          <div className={classes.root}>
            <div style={{ fontSize: 40 }}>Rent Book</div>
            <Divider />
            <div style={{ padding: 20 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
                  <Paper className={classes.paper}>
                    <div>
                      <img
                        src={book.bookCoverUrl}
                        alt="bookCover"
                        className={classes.coverImageStyle}
                      />
                    </div>
                    <div style={{ padding: 30 }}>
                      <div>
                        <ListItem style={{ fontSize: 24, fontWeight: "bold" }}>
                          {book.title}
                        </ListItem>
                        <ListItem style={{ fontSize: 20, color: "grey" }}>
                          By {book.author.firstName} {book.author.lastName}
                        </ListItem>
                        <ListItem>Genre: {book.genre}</ListItem>
                      </div>
                      <ListItem className={classes.textfieldRoot}>
                        <div style={{ marginRight: 10 }}>
                          Number of days to rent
                        </div>
                        <TextField
                          name="days"
                          type="number"
                          margin="normal"
                          variant="outlined"
                          style={{ outline: "none", width: "50%" }}
                          InputProps={{
                            classes: {
                              root: classes.inputRoot,
                              notchedOutline: classes.notchedOutline,
                              focused: classes.focused,
                            },
                            startAdornment: (
                              <InputAdornment position="start">
                                <RemoveIcon
                                  className={classes.iconStyle}
                                  onClick={this.decreaseDays}
                                />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <AddIcon
                                  className={classes.iconStyle}
                                  onClick={this.increaseDays}
                                />
                              </InputAdornment>
                            ),
                            inputProps: { min: 0 },
                          }}
                          InputLabelProps={{
                            classes: {
                              root: classes.labelRoot,
                              focused: classes.labelFocused,
                            },
                            shrink: true,
                          }}
                          inputRef={this.state.daysRef}
                          onWheel={() => this.handleWheel(this.state.daysRef)}
                          value={this.state.days}
                          onChange={this.handleChange}
                        />
                      </ListItem>
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
                  <Paper style={{ padding: 20 }}>
                    <div style={{ fontSize: 24, fontWeight: "bold" }}>
                      Order Details
                    </div>
                    <div style={{ fontSize: 20, fontWeight: "bold" }}>
                      OrderId: {orderId}
                    </div>
                    <br />
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Unit Price:</b>
                      <div>Rs.8 per day</div>
                    </ListItem>
                    <ListItem divider>
                      <b style={{ flexGrow: 1 }}>Number of days:</b>
                      <div>{this.state.days} days</div>
                    </ListItem>
                    <ListItem>
                      <b style={{ flexGrow: 1 }}>Total Price:</b>
                      <div>Rs.{this.state.days * 8}</div>
                    </ListItem>
                    <div>
                      By completing your purchase, your agree to these
                      <Link to="/termsandcondition">Terms and Condition</Link>.
                    </div>
                  </Paper>
                </Grid>
              </Grid>
              <div
                style={{
                  paddingTop: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.isAuth === true &&
                  this.state.emailVerified === true && (
                    <div>
                      <p style={{ fontSize: 24 }}>Pay with</p>
                      <p>The days must be greater than 0 to take rent</p>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <CustomerKhaltiPay
                          disabled={!this.state.validate}
                          classes={classes.buttonStyle}
                          payType="khalti"
                          rentedDays={this.state.days}
                          productIdentity={orderId}
                          productName={`${book.title}-${orderId}`}
                          rent={true}
                          // productUrl={`http://localhost:3000/book/rent/${book._id}`}
                          productUrl={`https://bookashram.netlify.app/book/rent/${book._id}`}
                          bookId={book._id}
                          total={this.state.totalPrice}
                          userToken={this.props.userToken}
                          reloadUrl={`/book/rent/${book._id}`}
                        />
                        <Button
                          className={classes.buttonStyle}
                          onClick={() => this.handleDialogOpen("paypal")}
                          disabled={!this.state.validate}
                        >
                          <img
                            src={PaypalLogo}
                            alt="paypal"
                            style={{ width: 150, height: 70 }}
                          />
                        </Button>
                      </div>
                      <RentDialogBox
                        open={this.state.dialogOpen}
                        handleClose={this.handleDialogClose}
                        book={this.state.book}
                        rentedDays={this.state.days}
                        payType={this.state.payType}
                        totalPrice={this.state.totalPrice}
                        changedCurrency={this.state.changedCurrency}
                      />
                    </div>
                  )}
              </div>
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.isAuth === true &&
                  this.state.emailVerified === false && (
                    <div style={{ fontSize: 20 }}>
                      You need to first verify your email address in order to
                      complete transaction.
                    </div>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <CustomLoader />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.isAuth,
  };
};

export default connect(mapStateToProps, null)(withStyles(useStyles)(RentBook));
